module.exports = __webpack_public_path__ + "img/cp2_02.4487a96d.jpg";